const DATE_FORMAT = "DD-MM-YYYY"; // Use this format to display on UI
const TIME_FORMAT = "HH:mm"
const DATE_TIME_FORMAT = "DD-MM-YYYY HH:mm";
const FULL_DATE_TIME_FORMAT = "DD-MM-YYYY HH:mm:ss";
const DATE_FORMAT_BACKEND_SIDE = "YYYY-MM-DD"; // Use this format to save in database
const DATE_TIME_FORMAT_BACKEND_SIDE = "YYYY-MM-DD HH:mm:ss"; // Use this format to save in database
export { DATE_FORMAT, DATE_TIME_FORMAT, TIME_FORMAT , DATE_FORMAT_BACKEND_SIDE, FULL_DATE_TIME_FORMAT, DATE_TIME_FORMAT_BACKEND_SIDE }
